import React from "react";
import { Link } from "react-router-dom";
import firsting from "../../assets/img/secondlearningbookimg.jpg";

const Data = [
  {
    id: 1,
    deviceSrc:
      "https://img.freepik.com/free-vector/hand-drawn-stock-market-concept_23-2149163669.jpg?w=1380&t=st=1673522796~exp=1673523396~hmac=8a89ac051a1f248ec32a6b01efd80dd6f5d2dd9304873a7b25d6158f9def0918",
    title: "eBook 1: Guide to Forex",
    desc:
      "Get a clear understanding of the basics of FX trading, from common jargon and popular trading products to what’s important when choosing a broker and how much money you’ll need to start trading.",
  },
  {
    id: 2,
    deviceSrc:
      "https://img.freepik.com/free-vector/hand-drawn-stock-market-concept-with-analysts_23-2149163670.jpg?w=1380&t=st=1673522883~exp=1673523483~hmac=6132b12c037728c7d178fdb70bf79d703485350e06f6e9b9bc6dbbc01f50ba41",
    title: "eBook 2: Guide to Web Terminal",
    desc:
      "Take a crash course in Web Terminal – the world’s most popular trading platform! We’ll guide you through the setup, how to place trades, use charts, indicators and drawing tools, plus more pro tips.",
  },
  {
    id: 3,
    deviceSrc:
      "https://img.freepik.com/free-vector/flat-design-credit-assessment_23-2149163665.jpg?w=1380&t=st=1673522982~exp=1673523582~hmac=0845f51a7ca5d6bf5425761657ebf43ee7fd91765170c68c3ce1259385a677f7",
    title: "eBook 3: Guide to Indicators",
    desc:
      "Understanding technical indicators is an essential skill for successful trading. We outline each main type, how to choose the right one for your strategy, how to combine indicators and much more!",
  },
  {
    id: 4,
    deviceSrc:
      "https://img.freepik.com/premium-vector/flat-design-investments-concept_23-2149163661.jpg?w=826",
    title: "eBook 4: Price Action Playbook",
    desc:
      "Learn to make smarter trade decisions as you discover technical knowledge of candlesticks, timeframes, patterns and how to better read markets to increase your probability of success.",
  },
  {
    id: 5,
    deviceSrc:
      "https://img.freepik.com/free-vector/stock-market-analysis_23-2148582512.jpg?w=826&t=st=1673523016~exp=1673523616~hmac=37e0aab50d401a2733bc5ee31ee7cbb5c3d26b5ae06b31d1b2da67e8972844db",
    title: "eBook 5: How to Manage Trades",
    desc:
      "Break down the anatomy of a trade and learn essential concepts like entry points, stop loss, take profit and break evens, plus how to manage risk, lot sizes and design a strategy that suits your goals.",
  },
];
const Middle = () => {
  return (
    <>
      {Data?.map((each, key) => {
        return (
          <div
            className={`${
              each.id === 2 ? "lg:flex-row" : "lg:flex-row-reverse"
            } flex items-center justify-center xl:gap-20 lg:gap-10 gap-2 mb-10 md:mb-0 flex-col my-10 xl:px-20 px-10`}
            key={key}
          >
            <img
              data-aos="fade-up"
              data-aos-duration="700"
              className="mb-4 lg:mb-10 object-cover xl:rounded-3xl rounded-md w-2/5"
              alt="hero"
              src={each.deviceSrc}
            />

            <div className="">
              <h1
                data-aos="fade-left"
                data-aos-duration="700"
                className="title-font text-3xl lg:text-4xl mb-4 font-medium text-gray-900 md:block flex item-center justify-center text-center lg:text-left"
              >
                {each.title}
              </h1>
              <p
                data-aos="fade-right"
                data-aos-delay="200"
                data-aos-duration="700"
                className="lg:mb-8 mb-4 lg:w-96 leading-relaxed text-sm md:text-base text-center lg:text-left sm:8 md:px-20 lg:px-0"
              >
                {each.desc}
              </p>
              <div className="lg:block flex item-center justify-center">
                <Link data-aos="fade-left" data-aos-duration="700" to="/app">
                  <button className="flex gap-2 transition ease-in-out text-white bg-yellow-500 border border-yellow-500 hover:border-gray-600 hover:bg-gray-600 font-medium rounded-md px-6 sm:py-3 py-1">
                    Open Account
                  </button>
                </Link>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default Middle;
